import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import { Box, Stack } from '@mui/system';

import { BLUE0, GREY } from '@/theme/palette';

const CollapsibleRow: React.FC<{
  icon: React.ReactElement;
  title: string;
  subtitle: string;
}> = ({ icon, title, subtitle }) => (
  <Accordion
    disableGutters
    elevation={0}
    square={false}
    sx={{
      border: `1px solid ${GREY}`,
      borderRadius: '10px !important',
      backgroundColor: '#FFFFFF',
      '&::before': { display: 'none' },
    }}
  >
    <AccordionSummary
      expandIcon={<ExpandMoreIcon sx={{ color: BLUE0 }} />}
      sx={{ px: 2, minHeight: 60, '& .MuiAccordionSummary-content': { my: 1.25 } }}
    >
      <Stack direction="row" spacing={2} alignItems="center">
        <Box sx={{ display: 'flex', color: BLUE0, '& svg': { fontSize: 24 } }}>{icon}</Box>
        <Box>
          <Typography sx={{ fontSize: 13.5, fontWeight: 600, color: BLUE0, lineHeight: 1.3 }}>{title}</Typography>
          <Typography sx={{ fontSize: 12, color: GREY }}>{subtitle}</Typography>
        </Box>
      </Stack>
    </AccordionSummary>
    <AccordionDetails>Future Feature</AccordionDetails>
  </Accordion>
);

const FieldLabel: React.FC<{ children: React.ReactNode; required?: boolean }> = ({ children, required }) => (
  <Typography component="label" sx={{ display: 'block', mb: 0.75, fontSize: 12.5, fontWeight: 600 }}>
    {children}
    {required && (
      <Box component="span" sx={{ color: 'error', ml: 0.25 }}>
        *
      </Box>
    )}
  </Typography>
);

const SectionHeading: React.FC<{ title: string; hint: string }> = ({ title, hint }) => (
  <Box sx={{ mb: 1.75 }}>
    <Typography sx={{ fontSize: 16, fontWeight: 700, lineHeight: 1.3 }}>{title}</Typography>
    <Typography sx={{ fontSize: 12.5, color: GREY, mt: 0.25 }}>{hint}</Typography>
  </Box>
);

export { CollapsibleRow, FieldLabel, SectionHeading };
